import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const BadEmailVerifier = () => (
  <ImageIcon src={Images.BadEmailVerifier} alt="Bad Email Verifier" />
);

export default BadEmailVerifier;
